import { isPresident } from '@src/utils/brand/brand-only-runtime'
import { AllCardTypes } from '@src/utils/card/type'

export const CARD_BG_IMAGE_PATHS: Record<AllCardTypes, string> = {
  REAL_CARD: '/_images/bg-card.svg',
  REAL_CARD_LOCKED: '/_images/bg-card-locked.svg',
  ON_DEMAND_CARD: '/_images/bg-card-on-demand.svg',
  ON_DEMAND_CARD_LOCKED: '/_images/bg-card-on-demand-locked.svg',
  VIRTUAL_CARD: isPresident()
    ? '/_images/president/bg-card-president-virtual.svg'
    : '/_images/bg-card-virtual.svg',
  VIRTUAL_CARD_LOCKED: '/_images/bg-card-virtual-locked.svg',
  METAL_CARD: '/_images/president/bg-card-metal.svg',
  METAL_CARD_LOCKED: '/_images/president/bg-card-metal-locked.svg',
}

export const ETC_CARD_BG_IMAGE_PATH = '/_images/ETCcard_front_1G.png'

export const CARD_ICON_IMAGE_PATHS: Record<
  | 'REAL_CARD'
  | 'REAL_CARD_LOCKED'
  | 'VIRTUAL_CARD'
  | 'VIRTUAL_CARD_LOCKED'
  | 'METAL_CARD'
  | 'METAL_CARD_LOCKED',
  string
> = {
  REAL_CARD: '/_images/icon-card.svg',
  REAL_CARD_LOCKED: '/_images/icon-card-locked.svg',
  VIRTUAL_CARD: isPresident()
    ? '/_images/president/icon-card-president-virtual.svg'
    : '/_images/icon-card-virtual.svg',
  VIRTUAL_CARD_LOCKED: '/_images/icon-card-virtual-locked.svg',
  METAL_CARD: '/_images/president/icon-card-metal.svg',
  METAL_CARD_LOCKED: '/_images/president/icon-card-metal-locked.svg',
}
